import React from 'react';
import ContactForm from '@/domains/contact/contactForm';

export default function Contact() {
  return <ContactForm />;
}
